import { render, staticRenderFns } from "./ServiceMenu.vue?vue&type=template&id=1d56a4a6&"
import script from "./ServiceMenu.vue?vue&type=script&lang=js&"
export * from "./ServiceMenu.vue?vue&type=script&lang=js&"
import style0 from "./ServiceMenu.vue?vue&type=style&index=0&id=1d56a4a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports